"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetModelInputsOrderByEnum = exports.ModelInputsApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ModelInputsApi extends runtime.BaseAPI {
    /**
     * Create a model input for execution setup
     * Create a new model input
     */
    createModelInputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.executionSetupId === null || requestParameters.executionSetupId === undefined)) {
                throw new runtime.RequiredError('executionSetupId', 'Required parameter requestParameters.executionSetupId was null or undefined when calling createModelInput.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelInputDTO === null || requestParameters.modelInputDTO === undefined)) {
                throw new runtime.RequiredError('modelInputDTO', 'Required parameter requestParameters.modelInputDTO was null or undefined when calling createModelInput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/executionSetup/input/{executionSetupId}`.replace(`{${"executionSetupId"}}`, encodeURIComponent(String(requestParameters.executionSetupId))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ModelInputDTOToJSON(requestParameters.modelInputDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelInputDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Create a model input for execution setup
     * Create a new model input
     */
    createModelInput(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createModelInputRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete a model input for execution setup
     * Remove the model input for execution setup base on id provided in the path
     */
    deleteModelInputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.id === null || requestParameters.id === undefined)) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling deleteModelInput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/executionSetup/input/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a model input for execution setup
     * Remove the model input for execution setup base on id provided in the path
     */
    deleteModelInput(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteModelInputRaw(requestParameters);
        });
    }
    /**
     * Get a model input of execution setup according id provided in the path
     * Get the execution setup input based on input id provided in the path
     */
    getModelInputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.id === null || requestParameters.id === undefined)) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getModelInput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/executionSetup/input/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelInputDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get a model input of execution setup according id provided in the path
     * Get the execution setup input based on input id provided in the path
     */
    getModelInput(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelInputRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Returns list of inputs which are defined for a execution setup. This serves as metadata required to generate a scenario values input form.
     * Get model inputs
     */
    getModelInputsRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.executionSetupId === null || requestParameters.executionSetupId === undefined)) {
                throw new runtime.RequiredError('executionSetupId', 'Required parameter requestParameters.executionSetupId was null or undefined when calling getModelInputs.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.orderBy === null || requestParameters.orderBy === undefined)) {
                throw new runtime.RequiredError('orderBy', 'Required parameter requestParameters.orderBy was null or undefined when calling getModelInputs.');
            }
            const queryParameters = {};
            if (requestParameters.executionSetupId !== undefined) {
                queryParameters['executionSetupId'] = requestParameters.executionSetupId;
            }
            if (requestParameters.orderBy !== undefined) {
                queryParameters['orderBy'] = requestParameters.orderBy;
            }
            if (requestParameters.orderDesc !== undefined) {
                queryParameters['orderDesc'] = requestParameters.orderDesc;
            }
            if (requestParameters.pageIndex !== undefined) {
                queryParameters['pageIndex'] = requestParameters.pageIndex;
            }
            if (requestParameters.pageSize !== undefined) {
                queryParameters['pageSize'] = requestParameters.pageSize;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/executionSetup/input`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelInputPagingResponseDTOFromJSON(jsonValue));
        });
    }
    /**
     * Returns list of inputs which are defined for a execution setup. This serves as metadata required to generate a scenario values input form.
     * Get model inputs
     */
    getModelInputs(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getModelInputsRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Update a model input for execution setup
     * Update the model input for execution setup base on id provided in the path
     */
    updateModelInputRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.id === null || requestParameters.id === undefined)) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling updateModelInput.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.modelInputDTO === null || requestParameters.modelInputDTO === undefined)) {
                throw new runtime.RequiredError('modelInputDTO', 'Required parameter requestParameters.modelInputDTO was null or undefined when calling updateModelInput.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                if (typeof this.configuration.accessToken === 'function') {
                    headerParameters["Authorization"] = this.configuration.accessToken("oauthToken", []);
                }
                else {
                    headerParameters["Authorization"] = this.configuration.accessToken;
                }
            }
            const response = yield this.request({
                path: `/executionSetup/input/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.ModelInputDTOToJSON(requestParameters.modelInputDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.ModelInputDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Update a model input for execution setup
     * Update the model input for execution setup base on id provided in the path
     */
    updateModelInput(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateModelInputRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ModelInputsApi = ModelInputsApi;
/**
    * @export
    * @enum {string}
    */
var GetModelInputsOrderByEnum;
(function (GetModelInputsOrderByEnum) {
    GetModelInputsOrderByEnum["Name"] = "name";
    GetModelInputsOrderByEnum["CreatedOn"] = "createdOn";
    GetModelInputsOrderByEnum["CreatedBy"] = "createdBy";
    GetModelInputsOrderByEnum["ModifiedOn"] = "modifiedOn";
    GetModelInputsOrderByEnum["ModifiedBy"] = "modifiedBy";
})(GetModelInputsOrderByEnum = exports.GetModelInputsOrderByEnum || (exports.GetModelInputsOrderByEnum = {}));
